module.exports = __webpack_public_path__ + "ba1e715c25b98cf7df66e36a67cd9e09.svg";


//////////////////
// WEBPACK FOOTER
// ./images/step3-gray.svg
// module id = 1129
// module chunks = 0